import { configureStore } from "@reduxjs/toolkit";
import UserStore from "./UserStore";

export default configureStore({
  reducer: {
    UserStore: UserStore,
  },
});
